module.exports = __webpack_public_path__ + "static/img/5890b7b77857733b25bef1a894e95273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_disable_04.png
// module id = sb04
// module chunks = 1